import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import SidebarDropdown from '../SidebarDropdown';

const mapStateToProps = (state, ownProps) => {
	const { match } = ownProps;

	if (match) {
		const pathLink = match.path;

		return {
			selectedName: pathLink
		};
	}

	return {};
};

const DropdownContainer = withRouter(connect(mapStateToProps)(SidebarDropdown));

export default DropdownContainer;


// WEBPACK FOOTER //
// ./src/components/widgets/containers/DropdownContainer.js